// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"143":"app","736":"vendor"}[chunkId] || chunkId) + "." + {"2":"1f8575c8","132":"3b3267fd","143":"6607ab8c","736":"71b563d3"}[chunkId] + ".css";
};